import http from 'hub-http/clients/apiClient';
export function getUsersVidyardStatus() {
  return http.get('filemanager/api/v4/portal-meta');
}